import { Link } from "react-router-dom";
import BAG from "../../../assets/images/upcoming-trip-bag.png";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getLocalItem } from "../../../_helpers/storageUtils";
import Loading from "../../../components/spinner/Loading";
import { getAllMyTrips } from "../services/mytrips.services";
import { FaArrowRightArrowLeft, FaArrowRightLong } from "react-icons/fa6";

const PendingTrips = () => {
  const MytripsList = useAppSelector((state) => state.mytrips.MytripsList);
  const loading = useAppSelector((state) => state.mytrips.loading);
  const dispatch = useAppDispatch();
  const user_guid = getLocalItem("user_guid");

  return (
    <>
      <Loading loading={loading} backgroundColor="white" />
      <div
        className="tab-pane fade"
        id="pills-pending-flight"
        role="tabpanel"
        aria-labelledby="pills-pending-flight-tab"
      >
        {MytripsList && MytripsList?.onprogress?.length > 0 ? (
          MytripsList?.onprogress.map((item: any, index: any) => {
            const isOneWayTrip = item?.flight_type === "ONEWAY";

            return (
              <div className="flight-card-wrapper">
                <div className="flight-header border-0">
                  <div>
                    <div className="flight-header-wrapper">
                      <h2>
                        {item?.departure_airport}
                        <span className="me-2 ms-2">
                          {isOneWayTrip ? (
                            <FaArrowRightLong />
                          ) : (
                            <FaArrowRightArrowLeft />
                          )}
                        </span>
                        {item?.arrival_airport}
                      </h2>
                      {isOneWayTrip && (
                        <span className="day-badge pending">In Progress</span>
                      )}
                    </div>
                    <p className="flight-status">
                      <strong>
                        {isOneWayTrip ? "One Way Flight" : "Round Trip Flight"}
                      </strong>{" "}
                      • Booking Ref. No. - <strong>{item?.portal_booking_no}</strong>
                    </p>
                  </div>
                  <button
                    onClick={() =>
                      dispatch(getAllMyTrips({ user_guid: user_guid }))
                    }
                    className="fill-btn manage-btn"
                  >
                    Check Status
                  </button>
                </div>
              </div>
            );
          })
        ) : (
          <div className="upcoming-trips">
            <img src={BAG} alt="upcoming-bag" />
            <h3>Looks empty, you've no pending bookings.</h3>
            <p>
              When you book a trip, and if it goes in processing then you will
              see it here.
            </p>
            <Link to={"/"} className="fill-btn">
              Plan a Trip
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default PendingTrips;
